// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 1.5L10 4.83333V10H22V22H18.5V16H11.5V22H2V1.5ZM8 20V6.16667L4 4.5V20H8Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.5 22H13.5V18H16.5V22Z"}}]};

const CityFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-filled',
    ref,
    icon: element,
  },
));

CityFilledIcon.displayName = 'CityFilledIcon';

export default CityFilledIcon;
